export default "__VITE_ASSET__B3uv2R$9__"